<vue-page-header
  pageTitle="{{ 'title.clients' | translate | async }}"
></vue-page-header>
<app-page-body>
  <app-clients-filters></app-clients-filters>
  <vue-section>
    <app-client-table></app-client-table>
  </vue-section>
</app-page-body>
